<template>
  <div class="card_manage_info_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="toExportZip">批量导出</el-button>
    </div>
    <div class="card_manage_info_box" :style="`height: ${windowHeight - 210}px;`">
      <div class="card_list_box">
        <div class="batch_card_item" :class="{'hengshu' : templateAxis==1}" :key="index" v-for="(item, index) in dataList"
             :style="`background: url(${item.cardUrl}) center center / contain no-repeat;`">
        </div>
      </div>
    </div>
    <el-pagination class="pagination-container" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :current-page.sync="listQuery.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {getIntegralCardPageList, exportBatchIntegralCardList,getIntegralCardTemplateInfoById} from '@/api/integralBank';

  export default {
    name: "cardManageInfo",
    data() {
      return {
        listQuery: {
          pageNo: 1,
          pageSize: 20,
          batchId: this.$route.query.batchId
        },
        dataList: [],
        total: null,
        templateAxis:1
      }
    },
    mixins: [windowResize],
    created() {
      getIntegralCardTemplateInfoById({id: this.$route.query.templateId}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.templateAxis = data.data.templateAxis;
          }
        });
      this.getIntegralCardPageList();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      toExportZip() {
        exportBatchIntegralCardList({batchId: this.listQuery.batchId})
          .then((res) => res.data)
          .then((data) => {
            if (data.result) {
              const prefixUrl =
                global.command === "production"
                  ? "https://www.zhxiaoyuan.cn/"
                  : "http://api.weixiaojia.net/";
              window.open(
                `${prefixUrl}thunder/archive/getArchiveByKey?archiveName=${data.data.zipName}&key=${data.data.key}&token=${this.$store.getters.token}`,
                "_blank"
              );
            }
          });
      },
      getIntegralCardPageList() {
        getIntegralCardPageList(this.listQuery).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.dataList = data.data.dataList;
            this.total = data.data.pagination.total;
          }
        });
      },
      //切换码数
      handleSizeChange(val) {
        this.listQuery.pageNo = 1;
        this.listQuery.pageSize = val;
        this.getIntegralCardPageList();
      },
      //切换页数
      handleCurrentChange(val) {
        this.listQuery.pageNo = val;
        this.getIntegralCardPageList();
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../styles/mixin';

  .card_manage_info_wrap{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .card_manage_info_box{
      @include scrollBar;
      .card_list_box{
        @include clearfix;
        overflow: hidden;
        .batch_card_item{
          float: left;
          width: 182px;
          height: 273px;
          margin: 15px 12px;
          border: 1px solid #f8f8f8;
        }
        .hengshu{
          height: 182px;
          width: 273px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/cardManageInfo.vue